import React from "react";
import WebinarCreateContainer from "@src/components/webinar/create/WebinarCreateContainer";

const WebinarCreatePage = () => <WebinarCreateContainer />;

export default WebinarCreatePage;
